import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMoney = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.683 4.643h9.786c1.655 0 2.684 1.167 2.684 2.82v6.229c0 1.653-1.03 2.821-2.685 2.821H5.683C4.03 16.513 3 15.345 3 13.692V7.464C3 5.81 4.034 4.643 5.683 4.643"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.15 7.485h.17c1.651 0 2.68 1.17 2.68 2.822v6.228c0 1.652-1.029 2.822-2.69 2.822H8.535c-1.66 0-2.69-1.17-2.69-2.822M5.707 13.566h1.181"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.504 10.578a1.926 1.926 0 1 0-3.85 0 1.926 1.926 0 0 0 3.85 0"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.449 7.59h-1.181"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMoney);
export default ForwardRef;
